<template>
    <div>
            <LabelHeader msg="项目模块"></LabelHeader>

        <el-form ref="form" :model="entity" label-width="80px">
            <el-form-item label="活动名称">
                <el-input v-model="entity.module" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">创建</el-button>
            </el-form-item>
        </el-form>
            <el-table ref="table" :data="plans" border stripe>
                <af-table-column prop="module" label="模块" align="center" :width="100"></af-table-column>
                <af-table-column title="操作" align="center" :width="80">
                    <template slot-scope="scope">
                        <el-popconfirm title="请确定要删除吗？"  @confirm="deleteRow(scope.row.id)" :key="scope.row.id">
                            <el-link type="danger"  slot="reference" :underline="false" >删除</el-link>
                        </el-popconfirm>
                    </template>
                </af-table-column>
            </el-table>

        </div>
</template>

<script>
import LabelHeader from '../../../eap/components/LabelHeader';
export default {
  props: ['project'],
  data () {
    return {
      entity: {
        module: null,
        projectCode: null,
        projectName: null
      },
      plans: [],
      params: {// 查询参数
        pageNo: 1,
        pageSize: 10,
        keyword: ''
      },
      idParam: {},
      codeParam: {},
      refreshing: false,
      codeDialogVisible: false,
      editDialogVisible: false,
      detailDialogVisible: false,
      pagination: { page: 1, size: 10, total: 0 }, // 分页参数
      projectList: [],
      webType: [],
      webInfo: ''
    };
  },
  components: { LabelHeader },
  mounted () {
    console.log(this.project);
    this.entity.projectName = this.project.name;
    this.entity.projectCode = this.project.code;
    this.queryPlans();
  },
  methods: {
    deleteRow (idVal) {
      jsKit.deleteByIdStr($api_pms.plan.delete, idVal, this.deleteCallback);
    },
    deleteCallback(res) {
      console.log(res);
      if (res.data.code === '200') {
        this.$message.success('删除成功');
        this.queryPlans();
      } else if (res.data.code === '500') {
        this.$message.error('删除失败:' + res.data.msg);
      }
    },
    queryPlans() {
      httpKit.post($api_pms.plan.searchByPorject, { 'projectCode': this.project.code }).then(res => {
        // this.$Loading.close();
        if (res.data.code === '200') {
          this.plans = res.data.data;
        } else {
          // this.$Message.error(res.data.msg);
        }
      });
    },

    openDetailDialog (val) {
      // console.log('选择 >>>  ', val);
      this.editDialogVisible = true;
      this.idParam = val;
    },
    next () {
      // console.log('主题 >>>  ', this.webInfo);
      this.codeParam.id = this.$route.query.id;
      this.codeParam.tableName = this.idParam.rdbmsName;
      this.codeParam.themeName = this.webInfo;
      this.editDialogVisible = false;
      this.codeDialogVisible = true;
      // this.$router.push({path:'/projectTemplate',query: {
      //     id: this.$route.query.id,
      //     tableName: this.idParam.rdbmsName,
      //     themeName: this.webInfo,
      // }})
    },
    getData () {
      httpKit.post($api_pms.project.tables, this.params).then(res => {
        if (res.data.code === '200') {
          this.projectList = res.data.data;
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    onSubmit() {
      httpKit.post($api_pms.plan.save, this.entity).then(res => {
        if (res.data.code === '200') {
          this.$message.success('添加成功');
          this.queryPlans();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getThemes () {
      httpKit.post($api_pms.codegen.search).then(res => {
        if (res.data.code === '200') {
          this.webType = res.data.data;
          this.webInfo = res.data.data[0].name;
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    closeCallback () {
      this.codeDialogVisible = false;
      this.getData();
    },
    refreshCallback () {
      // this.closeCallback();
    },
    close () {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less">
    .codeType{
        margin: 20px 30px;
    }
    .codeBtn{
        width: 100%;
        display: flex;
        justify-content: center;
        .h-btn.h-btn-blue{
            width: 120px;
        }
    }
</style>
